import { create } from "zustand";

export const useEditingChecklistState = create((set) => ({
    editingChecklist: null,
    setEditingChecklist: (checklist) => set({ editingChecklist: checklist }),
}));